export enum AdsStages {
	LIVE = 'live',
	MY_ADS = 'my_ads',
	CREATE = 'create',
}
